export default __webpack_public_path__ + "static/media/splash-1.f9dd3695.png";